module.exports = __webpack_public_path__ + "img/AG.fe720501.svg";